import { actions as groupUiActions } from '@ff-scene-plugins/photo-prints-redux/slices/groupsUiSlice';
import { PhotoPrintsPdpDispatch, PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';

export const prepareUiState = (
    dispatch: PhotoPrintsPdpDispatch,
    getState: () => PhotoPrintsPdpState
) => {
    const state = getState();
    const groupIds = state.project.groups.ids as string[];
    dispatch(groupUiActions.addMany({ ids: groupIds }));
};